export const FETCH_ALL_APPIAN_ICERT_CASES = 'FETCH_ALL_APPIAN_ICERT_CASES';
export const FETCH_ALL_APPIAN_ICERT_CASES_SUCCESS = 'FETCH_ALL_APPIAN_ICERT_CASES_SUCCESS';
export const FETCH_ALL_APPIAN_ICERT_CASES_FAILED = 'FETCH_ALL_APPIAN_ICERT_CASES_FAILED';

export function fetchAllAppianICertCases(payload) {
	return {
		type: FETCH_ALL_APPIAN_ICERT_CASES,
		payload: {
            caseNumber: payload['pwd-case-search']
        }
	};
}

export function fetchAllAppianICertCasesSuccess(payload) {
	return {
		type: FETCH_ALL_APPIAN_ICERT_CASES_SUCCESS,
		payload
	};
}

export function fetchAllAppianICertCasesFail(payload) {
	return {
		type: FETCH_ALL_APPIAN_ICERT_CASES_FAILED,
		payload
	};
};
